import { render, staticRenderFns } from "./ListaMmaProdesCar.vue?vue&type=template&id=60b7b181&lang=pug"
import script from "./ListaMmaProdesCar.vue?vue&type=script&lang=js"
export * from "./ListaMmaProdesCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports